<div
    *ngIf="animalForm.value.sex === '1'"
    id="reproductie"
    class="card"
>
    <div class="card-header">Reproducție</div>

    <div class="card-body">
        <div
            class="row column-gap-5"
            [formGroup]="animalForm"
        >
            <div class="col-auto d-flex align-items-center justify-content-center mb-2">
                <label class="m-0">
                    Cod Taur
                </label>

                <div>
                    <input
                        type="text"
                        placeholder="Cod Taur"
                        class="form-control ml-2"
                        formControlName="codtaur"
                        [ngClass]="{ disabled: disabledFields['codtaur'] }"
                    />
                </div>
            </div>

            <div class="col-auto d-flex align-items-center justify-content-center mb-2">
                <h5 *ngIf="animalForm.value.are_avizare_tauri">
                    Are Avizare Tauri
                </h5>

                <h5 *ngIf="!animalForm.value.are_avizare_tauri">
                    Nu are Avizare Tauri
                </h5>
            </div>

            <div
                class="col-auto"
                [ngClass]="{'w-100': autorizatiiMonta.controls.length}"
            >
                <div class="row">
                    <div class="col-auto d-flex align-items-center mb-2">
                        <h5 *ngIf="autorizatiiMonta.controls.length">
                            Autorizații Montă
                        </h5>
                        <h5 *ngIf="!autorizatiiMonta.controls.length">
                            Nu are Autorizații Montă
                        </h5>

                        <button
                            *ngIf="!disabledFields['autorizatii_monta']"
                            type="button"
                            class="btn btn-sm btn-blue ml-3"
                            (click)="adaugaAutorizatieMonta()"
                        >
                            <span class="mdi mdi-plus-circle"></span>
                            Adaugă Autorizație Montă
                        </button>
                    </div>
                </div>

                <ng-container *ngFor="let autorizatieMontaForm of autorizatiiMonta.controls; let index = index">
                    <div class="row mb-2" [formGroup]="autorizatieMontaForm">
                        <div class="col-auto mb-2">
                            <label *ngIf="index === 0">
                                Nr. doc.
                            </label>
                            <input
                                type="text"
                                placeholder="Număr document"
                                class="form-control w6"
                                formControlName="nr_document"
                                [ngClass]="{
                                    'is-invalid': submitted && autorizatieMontaForm.controls.nr_document.errors,
                                    'disabled': disabledFields['autorizatii_monta']
                                }"
                            />

                            <div
                                *ngIf="submitted && autorizatieMontaForm.controls.nr_document.errors?.required"
                                class="error-message invalid-feedback d-block"
                            >
                                Completarea acestui câmp este obligatorie.
                            </div>
                        </div>

                        <div class="col-auto mb-2">
                            <label *ngIf="index === 0">
                                Dată document
                            </label>
                            <app-date-picker
                                [selectedDate]="autorizatieMontaForm.controls.data_document.value"
                                (dateChanged)="autorizatieMontaForm.controls.data_document.setValue($event)"
                                [disabled]="disabledFields['autorizatii_monta']"
                                class="d-block"
                            >
                            </app-date-picker>

                            <div
                                *ngIf="submitted && autorizatieMontaForm.controls.data_document.errors?.required"
                                class="error-message invalid-feedback d-block"
                            >
                                Completarea acestui câmp este obligatorie.
                            </div>
                        </div>

                        <div class="col-auto mb-2">
                            <label *ngIf="index === 0">
                                Emitent
                            </label>
                            <input
                                type="text"
                                placeholder="Emitent"
                                class="form-control w14"
                                formControlName="emitent"
                                [ngClass]="{
                                    'is-invalid': submitted && autorizatieMontaForm.controls.emitent.errors,
                                    'disabled': disabledFields['autorizatii_monta'],
                                }"
                            />

                            <div
                                *ngIf="submitted && autorizatieMontaForm.controls.emitent.errors?.required"
                                class="error-message invalid-feedback d-block"
                            >
                                Completarea acestui câmp este obligatorie.
                            </div>
                        </div>

                        <div class="col-auto mb-2">
                            <label *ngIf="index === 0">
                                Dată început
                            </label>
                            <app-date-picker
                                [selectedDate]="autorizatieMontaForm.controls.data_inceput.value"
                                (dateChanged)="autorizatieMontaForm.controls.data_inceput.setValue($event)"
                                [disabled]="disabledFields['autorizatii_monta']"
                                class="d-block"
                            >
                            </app-date-picker>

                            <div
                                *ngIf="submitted && autorizatieMontaForm.controls.data_inceput.errors?.required"
                                class="error-message invalid-feedback d-block"
                            >
                                Completarea acestui câmp este obligatorie.
                            </div>
                        </div>

                        <div class="col-auto mb-2">
                            <label *ngIf="index === 0">
                                Dată sfârșit
                            </label>
                            <app-date-picker
                                [selectedDate]="autorizatieMontaForm.controls.data_sfarsit.value"
                                (dateChanged)="autorizatieMontaForm.controls.data_sfarsit.setValue($event)"
                                [disabled]="disabledFields['autorizatii_monta']"
                                class="d-block"
                            >
                            </app-date-picker>

                            <div
                                *ngIf="submitted && autorizatieMontaForm.controls.data_sfarsit.errors?.required"
                                class="error-message invalid-feedback d-block"
                            >
                                Completarea acestui câmp este obligatorie.
                            </div>
                        </div>

                        <div class="col-auto mb-2">
                            <label *ngIf="index === 0">
                                Fișier
                            </label>

                            <div class="upload-fisier">
                                <app-upload-fisier
                                    *ngIf="!autorizatieMontaForm.value.file_id && !disabledFields['autorizatii_monta']"
                                    (ApiResponse)="uploadServerResponse(autorizatieMontaForm, $event)"
                                ></app-upload-fisier>
                            </div>

                            <div
                                *ngIf="autorizatieMontaForm.value.file_name"
                                class="d-flex align-items-center"
                            >
                                <span
                                    class="file-button"
                                    (click)="downloadAutorizatieFile(autorizatieMontaForm)"
                                >
                                    {{ autorizatieMontaForm.value.file_name }}
                                </span>
                                <button
                                    *ngIf="!disabledFields['autorizatii_monta']"
                                    type="button"
                                    class="btn btn-lg p-0 ml-2 mdi mdi-delete text-danger"
                                    ngbTooltip="Șterge fișier"
                                    (click)="removeAutorizatieFile(autorizatieMontaForm)"
                                >
                                </button>
                            </div>
                        </div>

                        <div
                            *ngIf="!disabledFields['autorizatii_monta'] && !autorizatieMontaForm.value.id"
                            class="col-auto d-flex align-items-end mb-2"
                        >
                            <i
                                class="mdi mdi-close-circle text-danger fs-3 cursor-pointer"
                                ngbTooltip="Șterge"
                                (click)="clickStergeAutorizatieMonta(index)"
                            ></i>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
